import { render, staticRenderFns } from "./authTable.vue?vue&type=template&id=64483d40&scoped=true"
import script from "./authTable.vue?vue&type=script&lang=js"
export * from "./authTable.vue?vue&type=script&lang=js"
import style0 from "./authTable.vue?vue&type=style&index=0&id=64483d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64483d40",
  null
  
)

export default component.exports